<template>
  <div id="join-page">
    <div class="header-img">
      <img src="../../../static/image/join-mod/join-us-header-bg-img2.png" alt />
      <div class="infos">
        <div class="big-text">{{$theme ? "加入汉熵" : "AIoT ENTROPY"}}</div>
        <div class="fu-text">{{$theme ? "志在山顶的人，不会贪恋山腰的风景" : "Those who seek the summit won't be swayed by the view."}}</div>
        <div class="join-type">
          <div :class="{ 'is-active': joinType === 0 }" @click="inActive(0)">{{$theme ? "社会招聘" : "SOCIAL RECRUITMENT"}}</div>
          <div :class="{ 'is-active': joinType === 1, school: true }" @click="inActive(1)">{{$theme ? "校园招聘" : "CAMPUS RECRUITMENT"}}</div>
        </div>
      </div>
    </div>
    <!-- 工作 汉熵 -->
    <div class="work-in-hanshan">
      <div class="big-title">{{$theme ? "工作在汉熵" : "WORK AT AIoT ENTROPY"}}</div>
      <div class="desc">{{$theme ? "独木难支大厦，众志可成城郭" : "The power of unity is unstoppable"}}</div>
      <div class="work">
        
        <img src="../../../static/image/join-mod/work-at-han.png" alt="">
      </div>
    </div>

    <!-- 招聘 岗位-->
    <div class="recruitment">
      <div class="big-title">{{$theme ? "招聘岗位" : "JOB RECRUITMENT"}}</div>
      <div class="list-infos" :class="{'eng-li': !$theme}">
        <ul>
          <li
            :class="{ 'is-active': recruitmentType === i }"
            v-for="(item, i) in recruitmentList"
            :key="i"
            @click="selRecruitmentType(i)"
          >{{ $theme ? item.name : item.nameEng}}</li>
        </ul>
      </div>
      <div class="recruitment-content">
        <recruitment :showType="recruitmentType" />
      </div>
      <img class="point-bg" :src="pointBg" alt="">
    </div>
    <!-- 应聘 流程 -->
    <div class="apply-process">
      <div class="big-title" :class="{'eng-big-title': !$theme}">{{$theme ? "应聘流程" : "APPLICATION PROCESS"}}</div>
      
      <div class="apply-content">
        <apply-process />
      </div>
    </div>
    <ModelSix></ModelSix>
  </div>
</template>
<script>
import pointBg from '/static/image/home/point-bg.png'
import modTitle from '../../components/mod-title/Index.vue'
import workPic from './modules/work-pic/Index'
import welfare from './modules/comp-welfare/Index.vue'
import recruitment from './modules/recruitment/Index.vue'
import applyProcess from './modules/apply-process/Index.vue'
import ModelSix from '../home/components/model-six/Index.vue'
export default {
  components: {
    modTitle,
    workPic,
    welfare,
    recruitment,
    applyProcess,
    ModelSix
  },
  data() {
    return {
      name: '456',
      joinType: 0,
      pointBg,
      //workPicList: ['办公环境照片', '团建照片', '汉熵大讲堂', '汉熵精英'],
      workPicList: ['办公环境照片', '团建照片', '汉熵精英'],
      activeWorkPicIdx: 0,

      recruitmentList: [ {
        name: '社会招聘',
        nameEng: 'SOCIAL RECRUITMENT',
      },{
        name: '校园招聘',
        nameEng: 'CAMPUS RECRUITMENT',
      },],
      recruitmentType: 0
    }
  },
  mounted() {
    var element = document.getElementById("join-page");
    element.addEventListener("scroll", () => {
      var scrollTop = element.scrollTop;
      if (scrollTop>0) {
        // 页面已滚动到底部
        this.$bus.$emit("change-show-header", false);
      } else {
        this.$bus.$emit("change-show-header", true);
      }
    })
  },
  methods: {
    inActive(k) {
      // this.joinType = k;
      const { href } = this.$router.resolve({
        path: `/job-list/${k}/0`
      })
      window.open(href, '_blank')
      // this.$router.push(`/job-list/${k}/0`)
    },
    selPic(k) {
      this.activeWorkPicIdx = k
    },
    selRecruitmentType(k) {
      this.recruitmentType = k
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./Index.scss";
</style>
